import PropTypes from 'prop-types';

export const subledgerTaxEntriesTypes = PropTypes.arrayOf(PropTypes.shape({
  year: PropTypes.string.isRequired,
  countryTaxTypes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    entryTypes: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      activities: PropTypes.arrayOf(PropTypes.shape({
        bookTypes: PropTypes.arrayOf(PropTypes.shape({
          value: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
        })).isRequired,
        value: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        adjException: PropTypes.bool.isRequired,
        allowEntry: PropTypes.bool.isRequired,
        allowTopside: PropTypes.bool.isRequired,
        allowTransfer: PropTypes.bool.isRequired,
        glAccountList: PropTypes.string,
        toAdj: PropTypes.bool.isRequired,
        toFromAdj: PropTypes.bool.isRequired,
      })).isRequired,
    })).isRequired,
  })),
}));

export const accountActivityPropType = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  businessUnit: PropTypes.string,
  companyCode: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  legalEntity: PropTypes.string,
  postDate: PropTypes.string.isRequired,
  tradingPartner: PropTypes.string.isRequired,
});

export const ObligationPropTypes = PropTypes.shape({
  periodName: PropTypes.string,
  companyCode: PropTypes.string,
  legalEntity: PropTypes.string,
  countryCode: PropTypes.string,
  countryTaxType: PropTypes.string,
  description: PropTypes.string,
  stateMinimumTax: PropTypes.number,
  stateApptRate: PropTypes.number,
  statePrePostNol: PropTypes.string,
  fedFtcLimit: PropTypes.string,
  nol: PropTypes.string,
  recordVa: PropTypes.string,
  overrideTaxRate: PropTypes.number,
  overrideDefTaxRate: PropTypes.number,
  curTaxRate: PropTypes.number,
  defTaxRate: PropTypes.number,
  comments: PropTypes.string,
  severity: PropTypes.string,
  report: PropTypes.string,
  chartName: PropTypes.string,
  chartNameSource: PropTypes.string,
  connectionName: PropTypes.string,
  connectionNameSource: PropTypes.string,
  countryTaxTypeDescription: PropTypes.string,
  currentTaxRateSource: PropTypes.string,
  deferredTaxRateSource: PropTypes.string,
  enabledFlag: PropTypes.string,
  functionalCurrency: PropTypes.string,
  functionalCurrencySource: PropTypes.string,
  localTaxType: PropTypes.string,
  localTaxTypeSource: PropTypes.string,
  recordFtc: PropTypes.string,
  recordFtcSource: PropTypes.string,
  filingGroup: PropTypes.string,
  secondaryTax: PropTypes.string,
  secondaryTaxSource: PropTypes.string,
  taxCurrency: PropTypes.string,
  taxCurrencySource: PropTypes.string,
  statCurrency: PropTypes.string,
  statCurrencySource: PropTypes.string,
  usTaxType: PropTypes.string,
  usTaxTypeSource: PropTypes.string,
  homeOfficeCompanyCode: PropTypes.string,
  diagnostic: PropTypes.string,
});
